import { render, staticRenderFns } from "./OrganizationMenu.vue?vue&type=template&id=cab4c8a4&scoped=true&"
import script from "./OrganizationMenu.vue?vue&type=script&lang=js&"
export * from "./OrganizationMenu.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationMenu.vue?vue&type=style&index=0&id=cab4c8a4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cab4c8a4",
  null
  
)

export default component.exports